const messages = {
  bonus: {
    title: "Visão geral dos créditos de bónus",
    description: "Os bónus em euros são atribuídos às empresas participantes com base nos dados de vendas enviados.",
    lastMonth: "Mês passado",
    currentMonth: "Mês atual",
    totalCurrentYear: "Total do ano atual",
    totalLastYear: "Total do ano passado",
  },
  points: {
    title: "Visão geral dos créditos de pontos",
    period: "Ano civil em curso ({year})",
    totalAwarded: "Total de pontos atribuídos",
    redeemed: "Pontos resgatados",
    totalBalance: "Saldo total de pontos",
    redemptionRate: "Pontos resgatados como percentagem dos pontos atribuídos",
    averageAwarded: "Média de pontos atribuídos por pneu comprado",
    standardAwarded: "Pontos líquidos das linhas de venda calculadas, incluindo devoluções",
    bsPlusInclBooster: "Pontos das linhas de venda com quantidade positiva",
    perTire: "Pontos resgatados por pneu comprado",
  },
  tires: {
    title: "Visão geral da quantidade de pneus",
    description: "Pneus comprados pelos clientes",
    prevMonth: "Mês anterior",
    totalLastYear: "Total do ano passado",
    purchaseIndirect: "Compra através do grossista (indireta)",
    purchaseDirect: "Compra através do grossista (direta)",
    totalCurrentYear: "Total do ano atual",
    currentMonth: "Mês atual",
  },
  participating: {
    title: "Visão geral dos clientes participantes",
    description: "As empresas que se registam no BRIDGESTONE PLUS podem ser atribuídas por nós através do número de cliente.",
    total: "Total",
    newThisMonth: "Novos este mês",
    newThisYear: "Novos este ano",
    createdInCurrentMonth: "Criados no mês atual (pelo administrador)",
    loginsCurrentYear: "Logins no ano atual (após aceitar os termos e condições)",
  },
  brand: {
    title: "Marca",
    description: "As suas compras em detalhe",
    centerTitle: "Por\nmarca",
  },
  rim: {
    title: "Jante",
    centerTitle: "Por tamanho\nda jante",
  },
  tireGoals: {
    title: "Objetivos de pneus",
    subtitle: "Ganhe pontos pelas suas compras de pneus.",
    centerTitle: "Por tamanho\ndo pneu",
    tiresRemaining: "Pneus restantes",
    progressionTarget: "Objetivo de progressão: ",
    pointsEarnedPurchases: "pontos ganhos\n" + "pelas suas\n" + "compras",
    pointsEarnedBoosters: "pontos ganhos\n" + "pelos\n" + "boosters",
    purchasesDetail: "As suas compras em detalhe",
    cta: "Saiba mais sobre os seus pontos",
    pointsTitle: "Os seus pontos",
    pointsSubtitle: "Pontos ganhos nas suas compras Bridgestone",
    achievementsTitle: "As suas conquistas",
    achievementsSubtitle: "O seu compromisso anual:",
    achievementsSubtitle2: "pneus",
  },
  score: {
    title: "Pontuação",
    total: "Total",
    credits: "Créditos em",
    deductions: "Deduções em",
        unlockedPoints: "Pontos desbloqueados",
        pendingPoints: "Pontos pendentes",
  },
  score_extended: {
    title1: "Saldo de pontos",
    title2: "Bónus em euros",
    balance: "Saldo de pontos",
    bonus_in_euro: "Bónus em euros",
    date: "Data",
    added_points: "Pontos adicionados em",
    total_bands: "Total de marcas",
    goal: "Objetivo",
    tyres_previous_year: "Pneus vendidos no ano passado",
    tyres_current_year: "Pneus vendidos este ano",
    target_this_year: "Objetivo de vendas deste ano",
    bonus_this_year: "Bónus ganho (€)",
    loyal_minimum: "Nível mínimo de fidelização",
    bonus_multiplier: "Taxa multiplicadora do bónus",
  },
  lastImport: {
    label: "Última importação dos dados de vendas:",
    on: "em",
  },
  wholesalerTable: {
    title: "Clientes participantes em detalhe",
    description: "Abaixo encontrará as empresas que se registaram no BRIDGESTONE PLUS com o número de cliente da sua empresa. Pode usar os filtros para uma ordenação diferente ou a pesquisa para encontrar clientes.",
    columns: {
      customer_number: "N.º cliente",
      address_company_name: "Empresa",
      address_street: "Rua e n.º",
      address_postal_code: "Código postal",
      address_city: "Cidade",
      last_registration: "Último registo",
      network: "Rede",
      profile_group: "Grupo",
      tires_amount: "Quantidade de pneus",
      point_balance: "Saldo de pontos",
      bonus: "Bónus",
      details: "Detalhes",
    },
    searchPlaceholder: "Pesquisar",
  },
  dealerTable: {
    columns: {
      date: "Data",
      wholesaler_bs_plus: "Grossista BS+",
      customer_number: "Número de cliente",
      article: "Artigo",
      brand: "Marca",
      product: "Produto",
      type: "Tipo",
      inch: "Polegada",
      season: "Estação",
      amount: "Quantidade",
      points: "Pontos",
      activity: "Atividade",
      total_points: "Total de pontos",
    },
    title: "Tabela de dealers",
    description: "Visão geral das atividades dos dealers",
  },
  business_units: {
    title: "Unidades de negócio",
    centerTitle: "Por\nunidade",
  },
  season: {
    title: "Estação",
    centerTitle: "Por época\ndo ano",
  },
};

export default {
  messages,
};
